import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
export const BookingPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    // Set loading to false after a delay to allow Calendly to initialize
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => {
      document.body.removeChild(script);
      clearTimeout(timer);
    };
  }, []);
  return <div className="w-full min-h-screen bg-[#020311]" data-id="element-372">
      {/* Header with Logo */}
      <div className="flex justify-center py-6 sm:py-8" data-id="element-373">
        <a href="/" data-id="element-374">
          <img src="https://cdn.magicpatterns.com/uploads/pPv8sZAUYxABkDBucNAnxU/esa.png" alt="Equip Sales Academy Logo" className="h-14 sm:h-16 md:h-20" data-id="element-375" />
        </a>
      </div>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 pb-16" data-id="element-376">
        {/* Header Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-8" data-id="element-377">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#F5F5F7] leading-tight mb-4" data-id="element-378">
            Congrats, You're Qualified!
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#6366F1] mb-4" data-id="element-379">
            Please Book Your Sales OS Audit Call
          </h2>
          <p className="text-[#F5F5F7]/60 text-sm sm:text-base flex items-center justify-center gap-2" data-id="element-380">
            {isLoading && <Loader2 className="w-4 h-4 animate-spin" data-id="element-381" />}
            Calendar may take a moment to load...
          </p>
        </motion.div>

        {/* Calendly Embed */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative rounded-xl overflow-hidden bg-[#0A0A14] border border-[#6366F1]/20" data-id="element-382">
          {/* Loading Overlay */}
          {isLoading && <div className="absolute inset-0 bg-[#0A0A14] flex items-center justify-center z-10" data-id="element-383">
              <div className="flex flex-col items-center gap-4" data-id="element-384">
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#6366F1] border-t-transparent" data-id="element-385" />
                <p className="text-[#F5F5F7]/70 text-sm" data-id="element-386">Loading calendar...</p>
              </div>
            </div>}

          {/* Calendly Widget */}
          <div className="calendly-inline-widget" data-url="https://calendly.com/marc-equipsales/personalised-sales-audit-q" style={{
          minWidth: '320px',
          height: '700px'
        }} data-id="element-387" />
        </motion.div>

        {/* Back to Home Link */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="text-center mt-8" data-id="element-388">
          
        </motion.div>
      </main>
    </div>;
};